import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Send, Loader2, CheckCircle2, XCircle } from "lucide-react";

export const ZapierTestCard = ({ testIdPrefix = "zapier" }) => {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const send = async () => {
    setBusy(true); setRes(null);
    try { const { data } = await api.post("/integrations/astoria/test-zapier", { hook_url: url }); setRes(data); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <Card className="mb-5 p-6" data-testid={`${testIdPrefix}-test-card`}>
      <h3 className="font-semibold text-slate-900">Send a test lead to Zapier</h3>
      <p className="mt-1 text-sm text-slate-500">Sends one fictional lead (John Sample, lead ID ASTORIA-TEST-001, TCPA consent "no") to your Zapier Catch Hook so you can map fields. Your hook URL isn't saved, and no calls, emails or texts are sent.</p>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <Input type="password" autoComplete="off" value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://hooks.zapier.com/hooks/catch/123456/abcdef/" data-testid={`${testIdPrefix}-hook-url-input`} />
        <Button onClick={send} disabled={busy || !url.trim()} data-testid={`${testIdPrefix}-send-test-btn`} className="bg-indigo-700 hover:bg-indigo-800">
          {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Send className="mr-1.5 h-4 w-4" />} Send test lead
        </Button>
      </div>
      {res && (
        <div className={`mt-3 rounded-lg border p-3 text-sm ${res.accepted ? "border-emerald-200 bg-emerald-50 text-emerald-900" : "border-red-200 bg-red-50 text-red-800"}`} data-testid={`${testIdPrefix}-test-result`}>
          <div className="flex items-center gap-1.5 font-semibold">{res.accepted ? <CheckCircle2 className="h-4 w-4" /> : <XCircle className="h-4 w-4" />}HTTP {res.status_code} · {res.accepted ? "Zapier accepted the test lead" : "Zapier did not accept the test lead"}</div>
          <pre className="mt-2 overflow-x-auto whitespace-pre-wrap break-all text-xs">{JSON.stringify(res.response, null, 2)}</pre>
        </div>
      )}
    </Card>
  );
};
